import { PluginEquifaxIdMatrixRequest } from '../../../types/plugins';
import { ConstructPost } from '../../types/ConstructPost';
import { NonPaginatedResponse } from '../../types/NonPaginatedResponse';
import { PLUGIN_BASE_PATH } from '../constants/pluginBasePath';

export const runEquifaxIdMatrixRequest = (
  constructPost: ConstructPost,
  data: PluginEquifaxIdMatrixRequest,
): Promise<NonPaginatedResponse<null> | undefined> =>
  constructPost<NonPaginatedResponse<null>>(
    `${PLUGIN_BASE_PATH}/equifax-id-matrix-request`,
    { data },
    { preventDefaultErrorToast: true },
  );
